export default __webpack_public_path__ + "static/media/undraw_Processing_re_tbdu.ec9fa7af.svg";